import { render, staticRenderFns } from "./MapLayerLegendStatic.vue?vue&type=template&id=3ae13b97&"
import script from "./MapLayerLegendStatic.vue?vue&type=script&lang=js&"
export * from "./MapLayerLegendStatic.vue?vue&type=script&lang=js&"
import style0 from "./MapLayerLegendStatic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports